import Model from './model'

export default class User extends Model {
  constructor() {
    super()
    this.hydrate({
      id: null,
      name: '',
      last_name: '',
      email: '',
      active: true,
      username: '',
      password: '',
      password_confirmation: '',
      roles: [],
      profile: {},
      address: {},
      bank_detail: {},
      admin_notification: {
        admin: false,
        library: false
      }
    })
  }
}
